import { FetchAPI } from "./main";

export const MessagesAPI = {
    getMessageTypes: () => FetchAPI.getJson(`/community/communities/messages/types`),
    getMessages: (communityId) => FetchAPI.getJson(`/community/communities/${communityId}/messages`),
    updateMessages: (communityId, templateId) => FetchAPI.getJson(`/community/communities/${communityId}/messages/${templateId}`),
}
